
// src/errors/InsufficientPointsError.ts (New File)

/**
 * Custom error for scenarios where a user does not have enough points.
 */
export default class InsufficientPointsError extends Error {
  public username: string | undefined;
  public statusCode: number;

  constructor(message: string, username?: string, statusCode = 402) {
    super(message); // Pass message to the base Error class
    this.name = 'InsufficientPointsError'; // Set the error name
    this.username = username;
    this.statusCode = statusCode; // Store the relevant HTTP status code

    // Set the prototype explicitly for correct instanceof checks
    Object.setPrototypeOf(this, InsufficientPointsError.prototype);
  }
}
